(function(root, factory) {
  var api = factory();
  root.HDCartAvailability = api;
  if (typeof module !== "undefined" && module.exports) {
    module.exports = api;
  }
})(typeof window !== "undefined" ? window : globalThis, function() {
  function toInteger(value) {
    var parsed = parseInt(value, 10);
    return isNaN(parsed) ? 0 : parsed;
  }

  function normalizeLine(line, index) {
    var source = line && typeof line === "object" ? line : {};
    return {
      key: source.key != null ? String(source.key) : "line-" + index,
      variantId: source.variantId != null ? String(source.variantId) : "",
      quantity: Math.max(0, toInteger(source.quantity)),
      inventoryManagement:
        source.inventoryManagement != null ? String(source.inventoryManagement) : "",
      inventoryPolicy: source.inventoryPolicy != null ? String(source.inventoryPolicy) : "",
      variantMaxAvailable:
        source.variantMaxAvailable == null || source.variantMaxAvailable === ""
          ? null
          : Math.max(0, toInteger(source.variantMaxAvailable)),
      title: source.title != null ? String(source.title) : "",
    };
  }

  function isTrackedDenyVariant(line) {
    return (
      !!(line && line.inventoryManagement) &&
      String(line && line.inventoryPolicy) === "deny" &&
      line &&
      line.variantMaxAvailable != null
    );
  }

  function collectGroupedVariantState(lines) {
    var normalized = (Array.isArray(lines) ? lines : []).map(normalizeLine);
    var groupsByVariant = Object.create(null);

    normalized.forEach(function(line) {
      var variantId = line.variantId || "__unknown__";
      if (!groupsByVariant[variantId]) {
        groupsByVariant[variantId] = {
          variantId: line.variantId,
          totalQuantity: 0,
          sellableQuantity: line.variantMaxAvailable == null ? null : line.variantMaxAvailable,
          isTrackedDenyVariant: isTrackedDenyVariant(line),
          lineKeys: [],
          lines: [],
        };
      }

      var group = groupsByVariant[variantId];
      group.totalQuantity += line.quantity;
      group.lineKeys.push(line.key);
      group.lines.push(line);
      if (group.sellableQuantity == null && line.variantMaxAvailable != null) {
        group.sellableQuantity = line.variantMaxAvailable;
      }
      if (isTrackedDenyVariant(line)) {
        group.isTrackedDenyVariant = true;
      }
    });

    return Object.keys(groupsByVariant).map(function(variantId) {
      return groupsByVariant[variantId];
    });
  }

  function buildUnavailableLineState(lines) {
    var normalized = (Array.isArray(lines) ? lines : []).map(normalizeLine);
    var groups = collectGroupedVariantState(normalized);
    var lineStates = Object.create(null);
    var affectedLineKeys = [];

    normalized.forEach(function(line) {
      lineStates[line.key] = {
        isUnavailable: false,
        canAdjust: false,
        repairTargetQuantity: line.quantity,
      };
    });

    groups.forEach(function(group) {
      if (!group.isTrackedDenyVariant) return;
      var sellable = Math.max(0, toInteger(group.sellableQuantity));
      var remaining = sellable;

      group.lines.forEach(function(line) {
        var allowedQuantity = Math.max(0, Math.min(line.quantity, remaining));
        remaining = Math.max(0, remaining - allowedQuantity);
        var isUnavailable = line.quantity > allowedQuantity;

        lineStates[line.key] = {
          isUnavailable: isUnavailable,
          canAdjust: isUnavailable && allowedQuantity > 0,
          repairTargetQuantity: allowedQuantity,
        };

        if (isUnavailable) {
          affectedLineKeys.push(line.key);
        }
      });
    });

    return {
      hasUnavailableLines: affectedLineKeys.length > 0,
      checkoutBlocked: affectedLineKeys.length > 0,
      affectedLineKeys: affectedLineKeys,
      lineStates: lineStates,
      groupedVariants: groups,
    };
  }

  function buildRepairActionForLine(lines, lineKey) {
    var normalized = (Array.isArray(lines) ? lines : []).map(normalizeLine);
    var targetLine = normalized.find(function(line) {
      return line.key === lineKey;
    });

    if (!targetLine) return null;
    if (!isTrackedDenyVariant(targetLine)) return null;

    var siblingQuantity = normalized.reduce(function(sum, line) {
      if (line.variantId !== targetLine.variantId || line.key === targetLine.key) {
        return sum;
      }
      return sum + line.quantity;
    }, 0);

    var sellable = Math.max(0, toInteger(targetLine.variantMaxAvailable));
    var targetQuantity = Math.max(0, sellable - siblingQuantity);

    return {
      lineKey: targetLine.key,
      action: targetQuantity > 0 ? "adjust" : "remove",
      targetQuantity: targetQuantity,
      checkoutBlocked: true,
    };
  }

  return {
    collectGroupedVariantState: collectGroupedVariantState,
    buildUnavailableLineState: buildUnavailableLineState,
    buildRepairActionForLine: buildRepairActionForLine,
  };
});
